import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76c9587e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-xls mr-2" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-xls mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_outline_button = _resolveComponent("outline-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_outline_button, {
      "is-loading": _ctx.isSaving,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('saveButtonClick')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('general.button.save')), 1)
      ]),
      _: 1
    }, 8, ["is-loading"]),
    _createVNode(_component_outline_button, {
      class: "ml-5",
      type: "outline",
      onClick: _ctx.exportXlsx
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('proposal.list.content.table.body.actions.xls')), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_outline_button, {
      class: "ml-5",
      type: "outline",
      "is-loading": _ctx.isImporting,
      onClick: _ctx.triggerFileInput
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('proposal.actions.import_xlsx')), 1)
      ]),
      _: 1
    }, 8, ["is-loading", "onClick"]),
    _createElementVNode("input", {
      ref: "fileInput",
      type: "file",
      accept: ".xlsx",
      class: "hidden",
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFileSelect && _ctx.handleFileSelect(...args)))
    }, null, 544)
  ]))
}